import React from 'react';
import styled from 'styled-components';
import { BaseButtonLinkWrapper, ButtonLinkProps } from './BaseButtonLink';
import { SecondaryStyles, StyledSecondaryButtonProps } from './SecondaryButton';

type StyledSecondaryButtonLinkProps = StyledSecondaryButtonProps;

const SecondaryButtonLinkWrapper = styled(
  BaseButtonLinkWrapper
)<StyledSecondaryButtonLinkProps>`
  a {
    ${SecondaryStyles};
  }
`;

export type SecondaryButtonLinkProps = ButtonLinkProps &
  Partial<StyledSecondaryButtonLinkProps>;

export const SecondaryButtonLink: React.FC<SecondaryButtonLinkProps> = ({
  fullWidth = false,
  isActive = false,
  size = 'medium',
  children,
}) => {
  return (
    <SecondaryButtonLinkWrapper
      size={size}
      fullWidth={fullWidth}
      isActive={isActive}
    >
      {children}
    </SecondaryButtonLinkWrapper>
  );
};
